import { CheckMarkIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'

type Props = {
  name: string
  isLoading: boolean
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

const MissionStaffConfirmationModal = ({
  isOpen,
  name,
  isLoading,
  onCancel,
  onConfirm
}: Props) => {
  return (
    <Modal
      onCancel={onCancel}
      isOpen={isOpen}
      title={`Êtes-vous sûr de vouloir confirmer ce encadrant assigné "${name}" ?`}
      icon={CheckMarkIcon}
      isLoading={isLoading}
      variant={'confirmation'}
      actionButtonsOptions={{
        confirmText: 'Confirmer',
        cancelText: 'Fermer',
        onConfirm: onConfirm
      }}
    />
  )
}

export default MissionStaffConfirmationModal
